export default {
  activateLandingPageTitle: 'Acara',
  activateProductCardTitle: 'Acara',
  activateProductPageTitle: 'Pesan Acara',
  allProductsLandingPageTitle: 'Pesan Pengalaman Unik',
  apply: 'Terapkan',
  buyTickets: 'Beli tiket',
  cancel: 'Batal',
  clear: 'Hapus',
  clearFilters: 'Hapus filter',
  discoverExperiences: 'Temukan pengalaman',
  exclusive: 'Eksklusif',
  experience: 'pengalaman',
  experiencePhotoOfListing:
    'Foto pengalaman {{photoNumber}} dari daftar {{listingTitle}}',
  experiences: 'pengalaman',
  filterExperiences: 'Filter pengalaman',
  fromListingCard: 'Dari',
  hostedBy: 'Diselenggarakan oleh',
  hostLandingPageTitle: 'Pengalaman lokal',
  hostProductCardTitle: 'Pengalaman Lokal',
  hostProductPageTitle: 'Pesan Pengalaman Lokal',
  landingPageTitle: 'Pesan Pengalaman Unik',
  mainLandingPageTitle: 'Semua Pengalaman',
  more: 'Lainnya',
  noExperiencesFound: 'Tidak ada pengalaman ditemukan',
  noExperiencesFoundFor: 'Tidak ada pengalaman ditemukan untuk',
  experiencesFoundCount: '{{count}} pengalaman ditemukan',
  profileImageOfHost: 'Foto profil tuan rumah {{hostName}}',
  reserve: 'Pesan',
  reserveLandingPageTitle: 'Aktivitas & fasilitas',
  reserveProductCardTitle: 'Aktivitas',
  reserveProductPageTitle: 'Pesan Aktivitas & Fasilitas',
  resultsPageTitle: 'Pesan Pengalaman & Aktivitas',
};
